export default "__VITE_ASSET__4065da59__"